module.exports = __webpack_public_path__ + "static/media/SCBpaymentsMobile.29e5a38b.svg";